import { InvoiceStatuses } from "@legacy/core/utils/enums"

import TableViewTab from "@organisms/Table/TableViewControls/TableViewTab/TableViewTab"
import TableViewTabs from "@organisms/Table/TableViewControls/TableViewTabs/TableViewTabs"

import { INVOICES_ROUTES } from "@routes/invoices"

export const InvoiceTableViewTabs = () => (
    <TableViewTabs>
        <TableViewTab
            id="all_open"
            phase="open"
            title="All Open"
            isDefaultActiveTabForPhase={true}
            endpointKwargs={[
                ["status", InvoiceStatuses.pending],
                ["status", InvoiceStatuses.sent],
                ["ordering", "date_due"],
            ]}
            listEndpoint={INVOICES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={INVOICES_ROUTES.COUNT}
        />
        <TableViewTab
            id="pending"
            phase="open"
            title="Pending"
            endpointKwargs={[
                ["status", InvoiceStatuses.pending],
                ["ordering", "date_due"],
            ]}
            listEndpoint={INVOICES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={INVOICES_ROUTES.COUNT}
        />
        <TableViewTab
            id="outstanding"
            phase="open"
            title="Outstanding"
            endpointKwargs={[
                ["status", InvoiceStatuses.sent],
                ["is_overdue", "false"],
                ["ordering", "date_due"],
            ]}
            listEndpoint={INVOICES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={INVOICES_ROUTES.COUNT}
        />
        <TableViewTab
            id="overdue"
            phase="open"
            title="Overdue"
            endpointKwargs={[
                ["status", InvoiceStatuses.sent],
                ["is_overdue", "true"],
                ["ordering", "date_due"],
            ]}
            listEndpoint={INVOICES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={INVOICES_ROUTES.COUNT}
        />
        <TableViewTab
            id="all_closed"
            phase="closed"
            title="All Closed"
            isDefaultActiveTabForPhase={true}
            endpointKwargs={[
                ["status", InvoiceStatuses.paid],
                ["status", InvoiceStatuses.voided],
                ["status", InvoiceStatuses.forgiven],
                ["ordering", "-date_due"],
            ]}
            listEndpoint={INVOICES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={INVOICES_ROUTES.COUNT}
        />
        <TableViewTab
            id="paid"
            phase="closed"
            title="Paid"
            endpointKwargs={[
                ["status", InvoiceStatuses.paid],
                ["ordering", "-date_due"],
            ]}
            listEndpoint={INVOICES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={INVOICES_ROUTES.COUNT}
        />
        <TableViewTab
            id="voided"
            phase="closed"
            title="Voided"
            endpointKwargs={[
                ["status", InvoiceStatuses.voided],
                ["ordering", "-date_due"],
            ]}
            listEndpoint={INVOICES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={INVOICES_ROUTES.COUNT}
        />
        <TableViewTab
            id="forgiven"
            phase="closed"
            title="Forgiven"
            endpointKwargs={[
                ["status", InvoiceStatuses.forgiven],
                ["ordering", "-date_due"],
            ]}
            listEndpoint={INVOICES_ROUTES.LIGHTWEIGHT_LIST}
            countEndpoint={INVOICES_ROUTES.COUNT}
        />
    </TableViewTabs>
)
